
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { ThemeProvider } from "@/components/theme-provider";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Helmet } from "react-helmet";
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Solutions from "./pages/Solutions";
import Blog from "./pages/Blog";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import SolutionDetail from "./pages/SolutionDetail";
import BlogPost from "./pages/BlogPost";
import ServiceDetail from "./pages/ServiceDetail";

// ScrollToTop component to handle scrolling on route changes
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <ThemeProvider defaultTheme="light" storageKey="ssl-theme">
      <Router>
        <div className="flex min-h-screen flex-col">
          <ScrollToTop />
          <Helmet>
            <title>SSL Solution - Your Trusted Technology Partner</title>
            <meta name="description" content="SSL Solution provides comprehensive IT services, cybersecurity solutions, and digital transformation consulting to help businesses thrive in the digital age." />
            <meta name="keywords" content="IT services, cybersecurity, digital transformation, cloud solutions, software development, SSL Solution" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <meta property="og:title" content="SSL Solution - Your Trusted Technology Partner" />
            <meta property="og:description" content="Comprehensive IT services and solutions for modern businesses" />
            <meta property="og:type" content="website" />
            <meta name="twitter:card" content="summary_large_image" />
            <link rel="canonical" href="https://sslsolution.com" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <meta name="format-detection" content="telephone=no" />
            <meta name="theme-color" content="#ffffff" />
            
            {/* SEO improvements */}
            <meta name="robots" content="index, follow" />
            <meta name="author" content="SSL Solution" />
            <meta property="og:site_name" content="SSL Solution" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:url" content="https://sslsolution.com" />
            <meta property="og:image" content="/og-image.png" />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta name="twitter:title" content="SSL Solution - Your Trusted Technology Partner" />
            <meta name="twitter:description" content="Comprehensive IT services and solutions for modern businesses" />
            <meta name="twitter:image" content="/og-image.png" />
            <meta name="twitter:site" content="@sslsolution" />
            <meta name="geo.region" content="US" />
            <meta name="geo.placename" content="United States" />
            <link rel="alternate" hrefLang="en" href="https://sslsolution.com" />
          </Helmet>
          <Navbar />
          <main className="flex-1 pt-16">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/:id" element={<SolutionDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:id" element={<BlogPost />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
          <Toaster />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
